// extracted by mini-css-extract-plugin
export default {"right":"Right_right__5qZkv"};